import { render, staticRenderFns } from "./SindicatoRecebimento.vue?vue&type=template&id=4d0e7120&scoped=true"
import script from "./SindicatoRecebimento.vue?vue&type=script&lang=js"
export * from "./SindicatoRecebimento.vue?vue&type=script&lang=js"
import style0 from "./SindicatoRecebimento.vue?vue&type=style&index=0&id=4d0e7120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0e7120",
  null
  
)

export default component.exports